import { useEffect, useRef } from "react";
import { SEOHead } from "@/components/SEOHead";
import { usePhoneNumber } from "@/hooks/usePhoneNumber";
import { usePhoneBar } from "@/contexts/PhoneBarContext";
import { AdsQuizHero } from "@/components/ads/AdsQuizHero";
import { AdsStatsBar } from "@/components/ads/AdsStatsBar";
import { AdsDifferenceSection } from "@/components/ads/AdsDifferenceSection";
import { AdsRoofingSystems } from "@/components/ads/AdsRoofingSystems";
import { AdsThreeSteps } from "@/components/ads/AdsThreeSteps";
import { AdsRoofAgeSelector } from "@/components/ads/AdsRoofAgeSelector";
import { AdsVsCheapRoofers } from "@/components/ads/AdsVsCheapRoofers";
import { Testimonials } from "@/components/Testimonials";
import { AdsOffersFinancing } from "@/components/ads/AdsOffersFinancing";
import { AdsServiceAreaFooter } from "@/components/ads/AdsServiceAreaFooter";

const AdsRoofingQuizLanding = () => {
  const { setPhoneNumber } = usePhoneBar();
  const phoneInfo = usePhoneNumber(undefined);
  const heroRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setPhoneNumber(phoneInfo.tel);
  }, [phoneInfo.tel, setPhoneNumber]);

  const scrollToTop = () => {
    heroRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="theme-crimson" ref={heroRef}>
      <SEOHead
        cityName="Long Island"
        title="Save Thousands On A New Roof | Safeway Roofing"
        description="Long Island's #1 rated roofing contractor. GAF Master Elite certified. Get $500 off + 0% financing. Free roof inspection."
        canonical="https://quote.safewayroofingandchimney.com/ads/roofing-quiz"
      />
      <main className="min-h-screen">
        <AdsQuizHero />
        <AdsStatsBar />
        <AdsDifferenceSection />
        <AdsRoofingSystems onGetPricing={scrollToTop} />
        <AdsThreeSteps />
        <AdsRoofAgeSelector onSelect={scrollToTop} />
        <AdsVsCheapRoofers />
        <Testimonials />
        <AdsOffersFinancing onClaim={scrollToTop} />
      </main>
      <AdsServiceAreaFooter />
    </div>
  );
};

export default AdsRoofingQuizLanding;
